<template>
  <div :class="size" class="flexSolo">
      <div class="T1" :style="{
      }">
        <BoxCube v-if="item.header" :style="{padding: '0'}" :backgroundColor="'red'" :item="item.header"></BoxCube>
        <Hero v-if="item.hero" :item="item.hero"></Hero>
        <BoxCube :style="[
          {padding: item.body.paddingAll || '20px'},
          item.footer ? {paddingBottom: '10px'} : {}
        ]" :backgroundColor="'red'" :item="item.body"></BoxCube>
        <BoxCube v-if="item.footer" :style="{padding: '10px'}" :backgroundColor="'red'" :item="item.footer"></BoxCube>
      </div>
  </div>
</template>
<script>
export default {
  props: ['size', 'item']
}
</script>
<style lang="scss" scoped>
.flexSolo {
}
.T1 {
  background-color: #FFFFFF;
  overflow: hidden;
  background-color: #ffffff;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  overflow: hidden;
  background-color: #ffffff;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
}
</style>
